module.exports = __webpack_public_path__ + "l.no1.27e6843f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/l.no1.jpg
// module id = ngr9
// module chunks = 0